'use strict';

module.exports = trimTrailingLines;

var line = '\n';

/* Remove final newline characters from `value`. */
function trimTrailingLines(value) {
  var val = String(value);
  var index = val.length;

  while (val.charAt(--index) === line) { /* empty */ }

  return val.slice(0, index + 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/trim-trailing-lines/index.js
// module id = 110
// module chunks = 0